








































































































































































































































































































import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import ListModule from '@/store/ListModule';
import FilterComponent from '@/components/FilterComponent.vue';
import { fetchProspectsPrescriber } from '@/utils/filters';
import get from 'lodash/get';
import router from '../../router';
import Customer from '../../models/Customer';
import { postCustomerPrescriber, postSaveSearchPrescriber } from '../../api/api';
import AutocompleteAddress from '@/components/AutocompleteAddress.vue';
import AdresseGouvFeature from '@/models/AdresseGouvFeature';
import AdresseGouvResult from '@/models/AdresseGouvResult';
import uniqBy from 'lodash/uniqBy';
import axios from 'axios';
import { civilities } from '@/data/civilitiesCustomer';
import { projects } from '@/data/denounceProjects';
import AuthModule from '@/store/AuthModule';
import transformFilters from '@/utils/transformFilters';
import FilterModule from '@/store/FiltersModule';
import { isNumber } from 'lodash';



@Component({
    components: {
        FilterComponent,
        AutocompleteAddress,
    },
    filters: {
        pluralize: (value: string, suffix: string, bool: boolean) => {
            if (bool) {
                return `${value}${suffix}`;
            }
            return value;
        },
    },
})
export default class DenouncePopup extends Vue {
    @PropSync('active', {
        default: false,
    })
    pActive!: boolean;
    sending: boolean = false;
    prospectID: number | null = null;
    denounceID: number | null = null;
    selectedCountryCode: string = '+33';
    selectedCountryCode2: string = '+33';
    errors: any = null;
    showConfirm: boolean = false;
    newProspect = {
        civility: '',
        first_firstname: '',
        first_lastname: '',
        second_firstname: '',
        second_lastname: '',
        company_name: '',
        email: '',
        email_2: '',
        birthdate: undefined,
        phone: '',
        mobile: '',
        mobile_2: '',
        address: {
            postal_code: '',
            city: '',
            country: 'France',
        },
    };

    dataDenounce = {
        project: '',
        file: '',
        message_text: ''
    };

    countries = {
        "AF": "Afghanistan",
        "ZA": "Afrique du Sud",
        "AL": "Albanie",
        "DZ": "Algérie",
        "+49": "Allemagne",
        "AD": "Andorre",
        "AO": "Angola",
        "AI": "Anguilla",
        "AQ": "Antarctique",
        "AG": "Antigua-et-Barbuda",
        "AN": "Antilles néerlandaises",
        "SA": "Arabie saoudite",
        "AR": "Argentine",
        "AM": "Arménie",
        "AW": "Aruba",
        "AU": "Australie",
        "+43": "Autriche",
        "AZ": "Azerbaïdjan",
        "BS": "Bahamas",
        "BH": "Bahreïn",
        "BD": "Bangladesh",
        "BB": "Barbade",
        "BY": "Bélarus",
        "+32": "Belgique",
        "BZ": "Belize",
        "BJ": "Bénin",
        "BM": "Bermudes",
        "BT": "Bhoutan",
        "BO": "Bolivie",
        "BA": "Bosnie-Herzégovine",
        "BW": "Botswana",
        "BR": "Brésil",
        "BN": "Brunéi Darussalam",
        "BG": "Bulgarie",
        "BF": "Burkina Faso",
        "BI": "Burundi",
        "KH": "Cambodge",
        "CM": "Cameroun",
        "+1_CA": "Canada",
        "CV": "Cap-Vert",
        "EA": "Ceuta et Melilla",
        "CL": "Chili",
        "+86": "Chine",
        "CY": "Chypre",
        "CO": "Colombie",
        "KM": "Comores",
        "CG": "Congo-Brazzaville",
        "KP": "Corée du Nord",
        "+82": "Corée du Sud",
        "CR": "Costa Rica",
        "CI": "Côte d’Ivoire",
        "HR": "Croatie",
        "CU": "Cuba",
        "+45": "Danemark",
        "DG": "Diego Garcia",
        "DJ": "Djibouti",
        "DM": "Dominique",
        "EG": "Égypte",
        "SV": "El Salvador",
        "AE": "Émirats arabes unis",
        "EC": "Équateur",
        "ER": "Érythrée",
        "+34": "Espagne",
        "EE": "Estonie",
        "VA": "État de la Cité du Vatican",
        "FM": "États fédérés de Micronésie",
        "+1_US": "États-Unis",
        "ET": "Éthiopie",
        "FJ": "Fidji",
        "+358": "Finlande",
        "+33": "France",
        "GA": "Gabon",
        "GM": "Gambie",
        "GE": "Géorgie",
        "GS": "Géorgie du Sud et les îles Sandwich du Sud",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "+30": "Grèce",
        "GD": "Grenade",
        "GL": "Groenland",
        "GP": "Guadeloupe",
        "GU": "Guam",
        "GT": "Guatemala",
        "GG": "Guernesey",
        "GN": "Guinée",
        "GQ": "Guinée équatoriale",
        "GW": "Guinée-Bissau",
        "GY": "Guyana",
        "GF": "Guyane française",
        "HT": "Haïti",
        "HN": "Honduras",
        "HU": "Hongrie",
        "BV": "Île Bouvet",
        "CX": "Île Christmas",
        "CP": "Île Clipperton",
        "AC": "Île de l'Ascension",
        "IM": "Île de Man",
        "NF": "Île Norfolk",
        "AX": "Îles Åland",
        "KY": "Îles Caïmans",
        "IC": "Îles Canaries",
        "CC": "Îles Cocos - Keeling",
        "CK": "Îles Cook",
        "FO": "Îles Féroé",
        "HM": "Îles Heard et MacDonald",
        "FK": "Îles Malouines",
        "MP": "Îles Mariannes du Nord",
        "MH": "Îles Marshall",
        "UM": "Îles Mineures Éloignées des États-Unis",
        "SB": "Îles Salomon",
        "TC": "Îles Turks et Caïques",
        "VG": "Îles Vierges britanniques",
        "VI": "Îles Vierges des États-Unis",
        "+91": "Inde",
        "+62": "Indonésie",
        "IQ": "Irak",
        "IR": "Iran",
        "+353": "Irlande",
        "IS": "Islande",
        "IL": "Israël",
        "+39": "Italie",
        "JM": "Jamaïque",
        "+81": "Japon",
        "JE": "Jersey",
        "JO": "Jordanie",
        "KZ": "Kazakhstan",
        "KE": "Kenya",
        "KG": "Kirghizistan",
        "KI": "Kiribati",
        "KW": "Koweït",
        "LA": "Laos",
        "LS": "Lesotho",
        "LV": "Lettonie",
        "LB": "Liban",
        "LR": "Libéria",
        "LY": "Libye",
        "LI": "Liechtenstein",
        "LT": "Lituanie",
        "LU": "Luxembourg",
        "MK": "Macédoine",
        "MG": "Madagascar",
        "+60": "Malaisie",
        "MW": "Malawi",
        "MV": "Maldives",
        "ML": "Mali",
        "MT": "Malte",
        "MA": "Maroc",
        "MQ": "Martinique",
        "MU": "Maurice",
        "MR": "Mauritanie",
        "YT": "Mayotte",
        "+52": "Mexique",
        "MD": "Moldavie",
        "MC": "Monaco",
        "MN": "Mongolie",
        "ME": "Monténégro",
        "MS": "Montserrat",
        "MZ": "Mozambique",
        "MM": "Myanmar",
        "NA": "Namibie",
        "NR": "Nauru",
        "NP": "Népal",
        "NI": "Nicaragua",
        "NE": "Niger",
        "NG": "Nigéria",
        "NU": "Niue",
        "+47": "Norvège",
        "NC": "Nouvelle-Calédonie",
        "NZ": "Nouvelle-Zélande",
        "OM": "Oman",
        "UG": "Ouganda",
        "UZ": "Ouzbékistan",
        "PK": "Pakistan",
        "PW": "Palaos",
        "PA": "Panama",
        "PG": "Papouasie-Nouvelle-Guinée",
        "PY": "Paraguay",
        "+31": "Pays-Bas",
        "PE": "Pérou",
        "+63": "Philippines",
        "PN": "Pitcairn",
        "+48": "Pologne",
        "PF": "Polynésie française",
        "PR": "Porto Rico",
        "+351": "Portugal",
        "QA": "Qatar",
        "HK": "R.A.S. chinoise de Hong Kong",
        "MO": "R.A.S. chinoise de Macao",
        "QO": "régions éloignées de l’Océanie",
        "CF": "République centrafricaine",
        "CD": "République démocratique du Congo",
        "DO": "République dominicaine",
        "CZ": "République tchèque",
        "RE": "Réunion",
        "RO": "Roumanie",
        "+44": "Royaume-Uni",
        "RU": "Russie",
        "RW": "Rwanda",
        "EH": "Sahara occidental",
        "BL": "Saint-Barthélémy",
        "KN": "Saint-Kitts-et-Nevis",
        "SM": "Saint-Marin",
        "MF": "Saint-Martin",
        "PM": "Saint-Pierre-et-Miquelon",
        "VC": "Saint-Vincent-et-les Grenadines",
        "SH": "Sainte-Hélène",
        "LC": "Sainte-Lucie",
        "WS": "Samoa",
        "AS": "Samoa américaines",
        "ST": "Sao Tomé-et-Principe",
        "SN": "Sénégal",
        "RS": "Serbie",
        "CS": "Serbie-et-Monténégro",
        "SC": "Seychelles",
        "SL": "Sierra Leone",
        "+65": "Singapour",
        "SK": "Slovaquie",
        "SI": "Slovénie",
        "SO": "Somalie",
        "SD": "Soudan",
        "LK": "Sri Lanka",
        "+46": "Suède",
        "+41": "Suisse",
        "SR": "Suriname",
        "SJ": "Svalbard et Île Jan Mayen",
        "SZ": "Swaziland",
        "SY": "Syrie",
        "TJ": "Tadjikistan",
        "TW": "Taïwan",
        "TZ": "Tanzanie",
        "TD": "Tchad",
        "TF": "Terres australes françaises",
        "IO": "Territoire britannique de l'océan Indien",
        "PS": "Territoire palestinien",
        "+66": "Thaïlande",
        "TL": "Timor oriental",
        "TG": "Togo",
        "TK": "Tokelau",
        "TO": "Tonga",
        "TT": "Trinité-et-Tobago",
        "TA": "Tristan da Cunha",
        "TN": "Tunisie",
        "TM": "Turkménistan",
        "TR": "Turquie",
        "TV": "Tuvalu",
        "UA": "Ukraine",
        "EU": "Union européenne",
        "UY": "Uruguay",
        "VU": "Vanuatu",
        "VE": "Venezuela",
        "VN": "Viêt Nam",
        "WF": "Wallis-et-Futuna",
        "YE": "Yémen",
        "ZM": "Zambie",
        "ZW": "Zimbabwe"
    };

    get filteredCountryCodes() {
        return Object.entries(this.countries)
        .filter(([code]) => code.startsWith('+'))
        .reduce((acc, [code, country]) => {
            acc[code] = country;
            return acc;
        }, {} as Record<string, string>);
    }

    get fetchProspectsPrescriber() {
        return fetchProspectsPrescriber;
    }

    formatSuggestCountry(item: any) {
    return `${item.name}`;
    }

    async searchCountry(value: string) {
    // If no value, return empty array
    if (!value) return [];

    // Normalize the search value (remove accents, convert to lowercase)
    const normalizedValue = value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();

    const result = Object.entries(this.countries)
        .filter(([code, name]) => {
            // Normalize country name for comparison
            const normalizedName = name
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
            
            return normalizedName.includes(normalizedValue);
        })
        .map(([code, name]) => ({ code, name }))
        // Limit to 5 suggestions
        .slice(0, 5);

    return result;
    }

    onItemCountry(item: any) {
    this.newProspect.address.country = item.name;
    const localCountries: Record<string, string> = this.countries;
    const indicatif = Object.keys(localCountries).find((key: string) => {
        return localCountries[key] === item.name && key.startsWith('+');
    });
    if (indicatif) {
        this.selectedCountryCode = indicatif;
        this.selectedCountryCode2 = indicatif;
    }
    }


    formatSuggestZip(item: AdresseGouvFeature) {
        return `${item.properties.postcode} ${item.properties.city}`;
    }

    formatSuggestCity(item: AdresseGouvFeature) {
        return `${item.properties.city} ${item.properties.postcode}`;
    }

    formatPhoneNumber(phone: string, countryCode: string): string {
    // Retire tous les caractères non numériques
    let cleaned = phone.replace(/\D/g, '');
    
    // Si l'indicatif commence par '+', on le préfixe au numéro nettoyé avec un espace
    if (countryCode && countryCode.startsWith('+')) {
        return `(${countryCode}) ${cleaned}`;
    }
    return cleaned;
    }

    get sortedDialCodes() {
    const dialCodes = Object.entries(this.countries)
        .filter(([code]) => code.startsWith('+'))
        .map(([code, country]) => {
        const displayCode = code.split('_')[0]; // On garde juste le +1, pas le _US ou _CA
        return {
            code,         // On garde la clé originale comme value
            country,
            display: `${displayCode} (${country})`
        };
        })
        .sort((a, b) => a.code.localeCompare(b.code));

    // Option "aucun indicatif"
    dialCodes.unshift({ code: '', country: '', display: 'Aucun indicatif' });
    return dialCodes;
    }


    get programSelectedLength() {
        return ListModule.programsSelected.length;
    }

    get isTrial() {
        if (!AuthModule.isSubscriptionActive && AuthModule.isTrialActive) {
            return true;
        }

        return false;
    }

    onFilterProspect(prospectID: number | undefined) {
        if (prospectID === undefined) {
            this.prospectID = null;
        } else {
            this.prospectID = prospectID;
        }
    }

    getErrorsAddress(field: string): string[] {
        return get(
            this.errors,
            `children.address.children.${field}.errors`,
            []
        );
    }

    getErrors(field: string): string[] {
        return get(this.errors, `children.${field}.errors`, []);
    }

    isInvalid(field: string): boolean {
        let invalid = false;
        let error = this.getErrors(field);
        if(error.length>0){
            invalid = true;
        }
        return invalid;
    }

    isBlankProject(value: any): boolean {
        let invalid = false;


        if (this.errors) {

            // if input doesn't include rp pnl autrinv
            if (!['Rp', 'Dp', 'Ai'].includes(value)) {

                invalid = true;
            }
            else {
                invalid = false;

            }

        }

        return invalid;
    }

    isPhoneNumber(search: string): boolean {
    // Caractères autorisés : chiffres, espaces, points, virgules, points-virgules
    const validFormatRegex = /^[0-9\s.,;]+$/;
    
    // Nettoyer le numéro (ne garder que les chiffres)
    const cleanedNumber = search.replace(/[^\d]/g, '');
    
    return validFormatRegex.test(search) &&
           cleanedNumber.length >= 8 &&
           cleanedNumber.length <= 15;
    }

    isValidFrenchMobileNumber(phoneNumber: string): boolean {
    // Nettoyer le numéro (ne garder que les chiffres)
    const cleanedNumber = phoneNumber.replace(/[^\d]/g, '');
    
    // Si commence par 0, on veut exactement 10 chiffres
    if (cleanedNumber.startsWith('0')) {
        return cleanedNumber.length === 10;
    }
    
    // Sinon, on veut exactement 9 chiffres
    return cleanedNumber.length === 9;
    }

    isEmail(search: string): boolean {
        let invalid: boolean = false;
        if (this.errors) {
            const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            const result: boolean = expression.test(search);
            if (!result) {
                invalid = true;
            } else {
                invalid = false;
            }
        }
        return invalid;
    }

    isProjectInvalid(value: string) {

        let invalid: boolean = false;


        if (this.errors) {

            invalid = true;

            if (value.includes("Rp") || value.includes("Dp") || value.includes("Ai")) {
                invalid = false;
            }
        }
        // console.log("this -> : " + this.newDenounce.project);
        return invalid
    }


    // onUploadFiles(event: InputEvent): void {
    //     const files: ReadonlyArray<File> = [...(this.upload.files ? this.upload.files : [])];

    //     files.forEach((file) => {
    //         console.log(`File: ${file.name}`);
    //     });
    // }

    // get upload(): HTMLInputElement {
    //     return this.$refs.upload as HTMLInputElement;
    // }

    // data() {
    //     return {
    //         file: ''
    //     }
    // }
    // handleFileUpload(event: any) {
    //     this.dataDenounce.file = event.target.files[0];
    //     console.log(this.dataDenounce.file);

    // }

    async onSubmit() {
        this.showConfirm = true;


    }

    async searchZipAndCity(value: string) {
        const resp = await axios.get(
            `https://api-adresse.data.gouv.fr/search/?q=${value}`
        );
        const data: AdresseGouvResult = await resp.data;
        const result = uniqBy(data.features, item => {
            return `${item.properties.city} ${item.properties.postcode}`;
        });
        return result;
    }

    onItemZipAndCity(item: AdresseGouvFeature) {
        this.newProspect.address.postal_code = item.properties.postcode;
        this.newProspect.address.city = item.properties.city;
    }



    async accept() {
        this.showConfirm = false;
        try {
            this.sending = true;

            // Appliquer le formatage AVANT de créer ou mettre à jour le prospect
            this.newProspect.mobile = this.formatPhoneNumber(this.newProspect.mobile, this.selectedCountryCode);
            if (this.newProspect.mobile_2) {
            this.newProspect.mobile_2 = this.formatPhoneNumber(this.newProspect.mobile_2, this.selectedCountryCode2);
            }

            let prospectID: number | undefined = undefined;
            if (this.prospectID !== null) {
            prospectID = this.prospectID;
            } else {
            const customer: Customer = this.newProspect as Customer;
            const { data } = await postCustomerPrescriber(customer);
            prospectID = data.id;
            }

            const project = this.dataDenounce.project;
            const file = this.dataDenounce.file;
            const message_text = this.dataDenounce.message_text;

            // Appel des autres API...
            const filters = transformFilters(FilterModule.filters);
            await postSaveSearchPrescriber({
            programStatus: filters.status,
            programDeliveryDateMin: filters.dateInterval.min,
            programDeliveryDateMax: filters.dateInterval.max,
            lotPriceMin: filters.price.min,
            lotPriceMax: filters.price.max,
            departments: filters.departments,
            city: filters.city,
            programTaxSystem: filters.tax_system,
            lotType: filters.type,
            lotType2: filters.type2,
            program: filters.program,
            promoter: filters.promotor,
            customer: prospectID,
            });

            await ListModule.denounce({
            project: project,
            file: file,
            message_text: message_text,
            prospectID: prospectID
            });

            this.pActive = false;
            await this.$nextTick();
            const $vs = (this as any).$vs;
            $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Dénonce réussie',
            text: 'Votre dénonce a bien été enregistrée',
            });

            router.push({
            name: 'showProspect',
            params: { customerID: `${prospectID}` },
            });
        } catch (error) {
            this.errors = error.response.data.errors;
        } finally {
            this.sending = false;
        }
    }



    onValidCreateProspect() {
        let validtest = true;
        let projectError = this.errors = {};
        let civilityError = {};
        let emailError = {};
        let firstFirstnameError = {};
        let firstLastnameError = {};
        let mobileError = {};
        let secondFirstNameError = {};
        let secondLastNameError = {};
        let mobile2Error = {};
        let email2Error = {};
        let companyNameError = {};
        let postalCodeError = {};
        let cityError = {};
        let countryError = {};

        if(this.dataDenounce.project === ''){
            projectError = {errors: ["Not null"]};
            validtest = false;
        }
        
        if(this.newProspect.civility.trim() === ''){
            civilityError = {errors: ["La civilité doit être renseigné"]};
            validtest = false;
        }
        
        let email = this.newProspect.email.trim();
        if(email !== '' && email !== null){
            if(!/.+@.+\..+/.test(email)){
                emailError = {errors: ["Not Valid"]} ;
                validtest = false;
            }
        }else{
            emailError = {errors: ["Not null"]};
            validtest = false;
        }
        if(this.newProspect.civility !== "Société"){
            
            if(this.newProspect.first_firstname.trim() === ''){
                firstFirstnameError = {errors: ["Not null"]};
                validtest = false;
            }
            
            if(this.newProspect.first_lastname.trim() === ''){
                firstLastnameError = {errors: ["Not null"]};
                validtest = false;
            }
            
            if(this.newProspect.mobile.trim() !== ''){
                if(this.selectedCountryCode === '+33') {
                    if(!this.isValidFrenchMobileNumber(this.newProspect.mobile)){
                        mobileError = {errors: ["Numéro mobile français invalide"]};
                        validtest = false;
                    }
                } else {
                    if(!this.isPhoneNumber(this.newProspect.mobile)){
                        mobileError = {errors: ["Numéro non valide"]};
                        validtest = false;
                    }
                }
            }else{
                mobileError = {errors: ["Not null"]};
                validtest = false;
            }
        }
        if(this.newProspect.civility === "M. et Mme." || this.newProspect.civility === "M. et M." || this.newProspect.civility === "Mme. et Mme."){
            if(this.newProspect.second_firstname.trim() === ''){
                secondFirstNameError = {errors: ["Not null"]};
                validtest = false;
            }
            
            if(this.newProspect.second_lastname.trim() === ''){
                secondLastNameError = {errors: ["Not null"]};
                validtest = false;
            }

            if(this.newProspect.mobile_2.trim() !== ''){
                if(this.selectedCountryCode2 === '+33') {
                    if(!this.isValidFrenchMobileNumber(this.newProspect.mobile_2)){
                        mobile2Error = {errors: ["Numéro mobile français invalide"]};
                        validtest = false;
                    }
                } else {
                    if(!this.isPhoneNumber(this.newProspect.mobile_2)){
                        mobile2Error = {errors: ["Numéro non valide"]};
                        validtest = false;
                    }
                }
            }else{
                mobile2Error = {errors: ["Not null"]};
                validtest = false;
            }
        
            let email2 = this.newProspect.email_2.trim();
            if( email2 !== '' && email2 !== null){
                if(!/.+@.+\..+/.test(email2)){
                    email2Error = {errors: ["Not null"]} ;
                    validtest = false;
                }
            }else{
                email2Error = {errors: ["Not null"]};
                validtest = false;
            }
        }
        if(this.newProspect.civility === "Société" ){
            if(this.newProspect.company_name.trim() === ''){
                companyNameError = {errors: ["Not null"]};
                validtest = false;
            }
        }

        if (!this.newProspect.address.country || this.newProspect.address.country.trim() === '') {
        countryError = { errors: ["Veuillez sélectionner un pays dans la liste des suggestions"] };
        validtest = false;
        } else {
            // Check if the country name exists in the list of country names
            const countryExists = Object.values(this.countries).some(
                countryName => countryName === this.newProspect.address.country
            );
            if (!countryExists) {
                countryError = { errors: ["Veuillez choisir un pays parmi les suggestions proposées"] };
                validtest = false;
            }
        }

        if( this.newProspect.address.postal_code.trim() === '' ){
            postalCodeError = { errors: ["Le code postal doit être renseigné"]}
        }
        
        if( this.newProspect.address.city.trim() === '' ){
            cityError = { errors: ["La ville doit être renseigné"]}
        }

        if(!validtest){
            this.errors = {
                'children' : {
                    'project' : projectError,
                    'civility': civilityError,
                    'first_firstname': firstFirstnameError,
                    'first_lastname': firstLastnameError,
                    'second_firstname' : secondFirstNameError,
                    'second_lastname' : secondLastNameError,
                    'company_name' : companyNameError,
                    'mobile' : mobileError,
                    'mobile_2': mobile2Error,
                    'email' : emailError,
                    'email_2': email2Error,
                    'address': {
                        'children': {
                            'postal_code': postalCodeError,
                            'city' : cityError,
                            'country': countryError
                        }
                    }
                }
            }
        }else{
            this.showConfirm = true;
        }

        //return validtest;
    }

    onValidExistProspect() {

        let validtest = true;
        let projectError = this.errors = {};
        if(this.dataDenounce.project === ''){
            projectError = {errors: ["Not null"]};
            validtest = false;
        }

        let customerError = {};
        console.log('test prospect', this.prospectID);
        if(this.prospectID === null){
            customerError = {errors: ["Vous devez choisir un prospect"]};
            validtest = false;
        }

        if(!validtest){
            this.errors = {
                'children' : {
                    'project' : projectError,
                    'customer': customerError
                }
            }
        }else{
            this.showConfirm = true;
        }

        //return validtest;
    }

    get isSelectProspectFilled() {
        return this.prospectID !== null;
    }

    get isNewProspectNotEmpty() {
        return (
            (this.newProspect.civility &&
                this.newProspect.civility.trim() !== '') ||
            this.newProspect.first_firstname.trim() !== '' ||
            this.newProspect.first_lastname.trim() !== '' ||
            this.newProspect.second_firstname.trim() !== '' ||
            this.newProspect.second_lastname.trim() !== '' ||
            this.newProspect.company_name.trim() !== '' ||
            this.newProspect.mobile.trim() !== '' ||
            this.newProspect.mobile_2.trim() !== '' ||
            this.newProspect.email.trim() !== '' ||
            this.newProspect.email_2.trim() !== ''
        );
    }


    get isFormValid() {
        return true;
        return (
            this.programSelectedLength > 0 &&
            (this.isSelectProspectFilled ||
                (this.newProspect.civility &&
                    this.newProspect.civility.trim() !== '' &&
                    this.newProspect.first_firstname.trim() !== '' ||
                    this.newProspect.first_lastname.trim() !== '' ||
                    this.newProspect.second_firstname.trim() !== '' ||
                    this.newProspect.second_lastname.trim() !== '' ||
                    this.newProspect.company_name.trim() !== '' ||
                    this.newProspect.mobile.trim() !== '' ||
                    this.newProspect.email.trim() !== '' ||
                    this.newProspect.email_2.trim() !== '' ||
                    this.newProspect.mobile_2.trim() !== '' ||
                    this.newProspect.address.postal_code.trim() !== '' ||
                    this.newProspect.address.city.trim() !== '')
            ));
    }

    @Watch('pActive')
    onPActive() {
        if (this.pActive === false) {
            this.cleanup();
        }
    }
    @Watch('newProspect.civility', { deep: true })
    onChangeProspect() {
        if (this.newProspect.civility !== 'Société') {
            this.newProspect.company_name = '';
        } else {
            this.newProspect.first_firstname = '';
            this.newProspect.first_lastname = '';
        }
        if (
            this.newProspect.civility !== 'Mme. et Mme.' &&
            this.newProspect.civility !== 'Mr. et Mr.' &&
            this.newProspect.civility !== 'Mr. et Mme.'
        ) {
            this.newProspect.second_firstname = '';
            this.newProspect.second_lastname = '';
        }
    }
    cleanup() {
        this.prospectID = null;
        this.errors = null;
        this.newProspect.civility = '';
        this.newProspect.first_firstname = '';
        this.newProspect.first_lastname = '';
        this.newProspect.second_firstname = '';
        this.newProspect.second_lastname = '';
        this.newProspect.company_name = '';
        this.newProspect.mobile = '';
        this.newProspect.mobile_2 = '';
        this.newProspect.email = '';
        this.newProspect.email_2 = '';
        this.newProspect.address.country = 'France';
        this.newProspect.address.postal_code = '';
        this.newProspect.address.city = '';
        this.dataDenounce.project = '';
        this.dataDenounce.message_text = '';
        this.dataDenounce.file = '';
    }


    get customerCivilitiesArr() {
        return Object.keys(civilities).map(key => ({
            text: (civilities as any)[key],
            value: key,
        }));
    }

    get projectArr() {
        return Object.keys(projects).map(key => ({
            text: (projects as any)[key],
            value: key,
        }));
    }
}
